module.exports = __webpack_public_path__ + "img/545.c075e8dc.jpg";